import { HelpBoxMultipleIcon } from './HelpBoxMultipleIcon';

/**
 * author: Andrej Sharapov
 * id 52053B96-D72E-4C97-8841-EC5F646F08BB
 * name help-box-multiple
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-box-multiple.svg
 * tags
 */
export const QuestionBoxMultipleIcon = HelpBoxMultipleIcon;
export default QuestionBoxMultipleIcon